export default {"src":"/_next/static/media/eidr-d.2af4c1ec.svg","height":88,"width":105,"blurWidth":0,"blurHeight":0};